<span *ngIf="isShow" (click)="gotoTop()">
    <fa-icon [icon]="faArrowAltCircleUp" size="2x"></fa-icon>
</span>
